// src/components/FontLoader.js
import { useEffect } from "react";
import { useSelector } from "react-redux";

export default function FontLoader() {
    const sitedata = useSelector((store) => store.global.loginData);

    useEffect(() => {
        if (!sitedata?.fonts) return;

        const addFontLink = (linkUrl) => {
            if (!linkUrl) return;
            const existing = document.querySelector(`link[href="${linkUrl}"]`);
            if (!existing) {
                const link = document.createElement("link");
                link.href = linkUrl.replace("@import url('", "").replace("');", "");
                link.rel = "stylesheet";
                document.head.appendChild(link);
            }
        };

        // Add fonts dynamically
        addFontLink(sitedata.fonts.banner?.link);
        addFontLink(sitedata.fonts.heading?.link);
        addFontLink(sitedata.fonts.paragraph?.link);

        // Set CSS variables
        if (sitedata.fonts.banner?.name)
            document.documentElement.style.setProperty("--banner-font", sitedata.fonts.banner.name);
        if (sitedata.fonts.heading?.name)
            document.documentElement.style.setProperty("--heading-font", sitedata.fonts.heading.name);
        if (sitedata.fonts.paragraph?.name)
            document.documentElement.style.setProperty("--paragraph-font", sitedata.fonts.paragraph.name);

    }, [sitedata]);

    return null;
}
